export const LoadingBarIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <defs />
      <path
        d="M23.5,8.5v-3a2,2,0,0,0-2-2H2.5a2,2,0,0,0-2,2v3Z"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="#f8fafc"
      />
      <path d="M.5,8.5v11a2,2,0,0,0,2,2h19a2,2,0,0,0,2-2V8.5Z" fill="#00e6ca" />
      <path d="M5.25,21.5l13-13H.5v11a2,2,0,0,0,2,2Z" fill="#c4f0eb" />
      <path
        d="M.5,8.5v11a2,2,0,0,0,2,2h19a2,2,0,0,0,2-2V8.5Z"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.25,5.5a.25.25,0,1,0,.25.25.25.25,0,0,0-.25-.25"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.25,5.5a.25.25,0,1,0,.25.25.25.25,0,0,0-.25-.25"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.25,5.5a.25.25,0,1,0,.25.25.25.25,0,0,0-.25-.25"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5,14.981a2.5,2.5,0,0,1,2.5-2.5H18a2.5,2.5,0,0,1,0,5H6A2.5,2.5,0,0,1,3.5,14.981Z"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="#f8fafc"
      />
      <path
        d="M6,12.481a2.5,2.5,0,0,0,0,5H9.594l5-5Z"
        fill="#00e6ca"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.281,16.793l4.312-4.312"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M6.594,17.481l5-5" fill="none" stroke="#0f172a" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9.594,17.481l5-5" fill="none" stroke="#0f172a" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
